// removed by extract-text-webpack-plugin
module.exports = {"path":"retry-svg__path__2zaVv","head":"retry-svg__head__ufCmj","completed":"retry-svg__completed__pGKuD","loading":"retry-svg__loading__3O9wi","svg":"retry-svg__svg__X_kCj"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgr/retry/retry.svg.scss
// module id = 225
// module chunks = 0